export function LoadingTextSkeleton({ className }: { className: string | undefined }) {
	return <div className={`w-50 h-6 rounded-lg bg-gray-300 animate-pulse ${className ?? ""}`} />;
}
